var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87084 1.11111C5.87084 0.497461 5.39772 0 4.81409 0C4.23046 0 3.75734 0.497461 3.75734 1.11111V1.97531H2.46575C1.10395 1.97531 0 3.13606 0 4.5679V9.01235V17.4074C0 18.8393 1.10396 20 2.46575 20H14.6771C16.0389 20 17.1429 18.8393 17.1429 17.4074V9.01235V4.5679C17.1429 3.13605 16.0389 1.97531 14.6771 1.97531H13.3855V1.11111C13.3855 0.497461 12.9124 0 12.3288 0C11.7451 0 11.272 0.497461 11.272 1.11111V1.97531H5.87084V1.11111ZM15.0294 7.90123V4.5679C15.0294 4.36335 14.8716 4.19753 14.6771 4.19753H13.3855V5.06173C13.3855 5.67538 12.9124 6.17284 12.3288 6.17284C11.7451 6.17284 11.272 5.67538 11.272 5.06173V4.19753H5.87084V5.06173C5.87084 5.67538 5.39772 6.17284 4.81409 6.17284C4.23046 6.17284 3.75734 5.67538 3.75734 5.06173V4.19753H2.46575C2.27121 4.19753 2.1135 4.36335 2.1135 4.5679V7.90123H15.0294ZM2.1135 10.1235H15.0294V17.4074C15.0294 17.612 14.8716 17.7778 14.6771 17.7778H2.46575C2.27121 17.7778 2.1135 17.612 2.1135 17.4074V10.1235Z",
    fill: "#7C7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.3399a4d1310e727903fe8b30f448e8b5.svg";
export { ForwardRef as ReactComponent };